import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Valuta } from './valuta';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-valuta',
  templateUrl: './valuta.component.html'
})
export class ValutaComponent extends BaseModalContainer<Valuta> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Valuta>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }


  ngOnInit() {
  }

}
